import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useNotesListing = ({
  accountId,
  propertyId,
  type
}: {
  accountId: string;
  propertyId: string;
  type: string;
}) => {
  const axios = useAxios();
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["notes-list", accountId, propertyId, type],
    queryFn: async () => {
      const urlKey = t("notes");
      const params: Record<string, string> = {
        accountId,
        // pubPropertyId: propertyId
      };

      if (type) {
        params.type = type;
      }
      const response = await axios.get(urlKey, { params });
      return response.data.data;
    },
    refetchOnWindowFocus: false
  });
};
